import { SUB_PLATFORM } from '@lusha/source-platforms';
export const APPS = {
    CONTACTS: 'lusha-contacts',
    SEARCH_TAB: 'lusha-contacts/search',
    GMAIL: 'lusha-gmail',
    SCOUT: 'lusha-scout',
    BULK: 'lusha-bulk',
};
export const PLATFORMS = {
    LINKEDIN_SALES_NAVIGATOR: 'linkedinSalesNavigator',
    LINKEDIN_RECRUITER_LITE: 'linkedinRecruiterLite',
    LINKEDIN_RECRUITER_PRO: 'linkedinRecruiterPro',
    LINKEDIN: 'linkedin',
    LINKEDIN_PUBLIC: 'linkedin-public',
    SALESFORCE_CLASSIC: 'salesforceClassic',
    SALESFORCE_CLASSIC_ACCOUNT: 'salesforceClassicAccount',
    SALESFORCE_LIGHTNING: 'salesforceLightning',
    SALESFORCE_LIGHTNING_ACCOUNT: 'salesforceLightningAccount',
    GMAIL: 'gmail',
    SCOUT: 'scout',
    HUBSPOT: 'hubspot',
    HUBSPOT_COMPANY: 'hubspotCompany',
};
export const SAVE_CONTACT_SUB_PLATFORMS = {
    linkedinSalesNavigator: SUB_PLATFORM.LINKEDIN_SALES_NAVIGATOR,
    linkedinRecruiterLite: SUB_PLATFORM.LINKEDIN_RECRUITER_LITE,
    linkedinRecruiterPro: SUB_PLATFORM.LINKEDIN_RECRUITER_PRO,
    linkedin: SUB_PLATFORM.LINKEDIN_MAIN,
    [PLATFORMS.LINKEDIN_PUBLIC]: SUB_PLATFORM.LINKEDIN_PUBLIC,
    salesforceClassic: SUB_PLATFORM.SALESFORCE_CLASSIC,
    salesforceClassicAccount: SUB_PLATFORM.SALESFORCE_CLASSIC,
    salesforceLightning: SUB_PLATFORM.SALESFORCE_LIGHTNING,
    salesforceLightningAccount: PLATFORMS.SALESFORCE_LIGHTNING,
    gmail: SUB_PLATFORM.GMAIL,
    scout: PLATFORMS.SCOUT,
    hubspot: SUB_PLATFORM.HUBSPOT,
    hubspotCompany: SUB_PLATFORM.HUBSPOT,
};
export const SALESFORCE_PLATFORMS = [
    PLATFORMS.SALESFORCE_CLASSIC,
    PLATFORMS.SALESFORCE_CLASSIC_ACCOUNT,
    PLATFORMS.SALESFORCE_LIGHTNING,
    PLATFORMS.SALESFORCE_LIGHTNING_ACCOUNT,
];
export const LINKEDIN_PLATFORMS = [
    PLATFORMS.LINKEDIN_RECRUITER_PRO,
    PLATFORMS.LINKEDIN_RECRUITER_LITE,
    PLATFORMS.LINKEDIN_SALES_NAVIGATOR,
    PLATFORMS.LINKEDIN_PUBLIC,
    PLATFORMS.LINKEDIN,
];
export const HUBSPOT_PLATFORMS = [PLATFORMS.HUBSPOT, PLATFORMS.HUBSPOT_COMPANY];
export const LINKEDIN_RECRUITER_PLATFORMS = [PLATFORMS.LINKEDIN_RECRUITER_PRO, PLATFORMS.LINKEDIN_RECRUITER_LITE];
